import { createFileRoute } from '@tanstack/react-router';
import { AuditPage } from '@/features/settings/AuditPage';

export const Route = createFileRoute('/app/settings/audit')({
  component: AuditPage,
  staticData: { title: 'Audit log · Settings' },
});
